/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { Time } from "./time";

export class DateTime extends Date {
  static monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  static monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  static weekDaysLong = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  static weekDayShort = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  static weekDayMedium = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  dateFormat = "Y-m-d";
  timeFormat = "24hr";
  translator = null;

  constructor(date, translator = null) {
    super(date);
    this.translator = translator || ((str) => str); // fallback to identity function
  }

  setDateFormat(format) {
    this.dateFormat = format;
  }

  setTimeFormat(format) {
    this.timeFormat = format;
  }

  static parseMysqlDate(date, translator = null) {
    var result = new DateTime(null, translator);

    var datetimeArr = date.split(" ");
    if (datetimeArr.length) {
      var dateArr = datetimeArr[0].split("-");

      result.setYear(parseInt(dateArr[0], 10));
      result.setMonth(parseInt(dateArr[1], 10) - 1, parseInt(dateArr[2]));
      if (datetimeArr.length > 1) {
        var timeArr = datetimeArr[1].split(":");

        result.setHours(parseInt(timeArr[0], 10), parseInt(timeArr[1], 10), 0, 0);
      }
    }
    return result;
  }

  getFormattedDate(nonEscape) {
    return this.formatDate(this.dateFormat, nonEscape);
  }

  getFormattedDateTime(nonEscape) {
    return this.getFormattedDate(nonEscape) + " " + this.getFormattedTime();
  }

  getFormattedTime() {
    return new Time(this.getMysqlTime()).getFormattedTime(this.timeFormat);
  }

  getMysqlDate() {
    var month = this.getMonth() + 1;
    month = month > 9 ? month : "0" + month;

    var day = this.getDate();
    day = day > 9 ? day : "0" + day;

    var year = this.getFullYear();

    var result = year + "-" + month + "-" + day;

    return result;
  }

  getMysqlTime() {
    var hours = this.getHours();
    hours = hours > 9 ? hours : "0" + hours;

    var mins = this.getMinutes();
    mins = mins > 9 ? mins : "0" + mins;

    var seconds = this.getSeconds();
    seconds = seconds > 9 ? seconds : "0" + seconds;

    return hours + ":" + mins + ":" + seconds;
  }

  getMonthName(type) {
    return this.getMonthNameByIndex(this.getMonth(), type);
  }

  getMonthNameByIndex(index, type) {
    switch (type) {
      case "short":
        return DateTime.monthsShort[index];
      case "short_translated":
        return this.translator(DateTime.monthsShort[index]);
      case "long_translated":
        var monthName = DateTime.monthsLong[index];
        return this.translator("_" + monthName + "_", true) || this.translator(monthName);
      default:
        return DateTime.monthsLong[index];
    }
  }

  formatDate(format, nonEscape) {
    if (nonEscape) {
      //TODO how do we handle nonEscape?
    }

    var result = [];
    for (var i = 0; i < format.length; i++) {
      var str = format[i];
      switch (format[i]) {
        case "d":
          str = this.getDate() > 9 ? this.getDate() : "0" + this.getDate();
          break;
        case "j":
          str = this.getDate();
          break;
        case "m":
          str = this._fixZero(this.getMonth() + 1);
          break;
        case "Y":
          str = this.getFullYear();
          break;
        case "y":
          str = ("" + this.getFullYear()).substr(2, 2);
          break;
        case "M":
          str = this.translator(DateTime.monthsShort[this.getMonth()]);
          break;
        case "F":
          var monthName = this.getMonthName();
          str = this.translator("_" + monthName + "_", true) || this.translator(monthName);
          break;
        case "l":
          str = this.translator(DateTime.weekDaysLong[this.getDay()]);
          break;
        case "D":
          str = this.translator(DateTime.weekDayMedium[this.getDay()]);
          break;
        case "H":
          str = this._fixZero(this.getHours());
          break;
        case "i":
          str = this._fixZero(this.getMinutes());
          break;
        case "s":
          str = this._fixZero(this.getSeconds());
          break;
        default:
      }

      result.push(str);
    }
    return result.join("");
  }

  _fixZero(val) {
    return val > 9 ? val : "0" + val;
  }
}
